import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import {
  instituteTypeListSchema,
  type CreateInstituteTypePayload,
  type InstituteType,
  type UpdateInstituteTypePayload,
} from '../types/instituteType.types';

export const instituteTypeQueryKeys = {
  all: () => ['institute-types'] as const,
  list: () => [...instituteTypeQueryKeys.all(), 'list'] as const,
  active: () => [...instituteTypeQueryKeys.all(), 'active'] as const,
};

export const instituteTypesQueryOptions = () =>
  queryOptions({
    queryKey: instituteTypeQueryKeys.list(),
    queryFn: async (): Promise<InstituteType[]> => {
      const res = await apiClient.get(API.instituteType.list);
      return instituteTypeListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export const activeInstituteTypesQueryOptions = () =>
  queryOptions({
    queryKey: instituteTypeQueryKeys.active(),
    queryFn: async (): Promise<InstituteType[]> => {
      const res = await apiClient.get(API.instituteType.listActive);
      return instituteTypeListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export async function createInstituteType(payload: CreateInstituteTypePayload): Promise<void> {
  await apiClient.post(API.instituteType.create, payload);
}

export async function updateInstituteType(
  id: number,
  payload: UpdateInstituteTypePayload,
): Promise<void> {
  await apiClient.patch(API.instituteType.update(id), payload);
}

export async function deleteInstituteType(id: number): Promise<void> {
  await apiClient.delete(API.instituteType.delete(id));
}
